import { ErrorModalTypes } from '@Store/index';
import { OnboardingFormFields } from '@Types/index';
import { Icons } from '@Components/icon/Icon.tsx';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { ErrorType } from '@Services/errors/errorType.ts';
import type { IErrorHandling } from '@Types/index';

export const GeneralErrorMap = {
  INCORRECT_STATE: { errorCode: 4012, errorType: ErrorType.TECHNICAL },
  CUSTOMER_ALREADY_REGISTER: { errorCode: 4035, errorType: ErrorType.TECHNICAL },
  PLEASE_WAIT: { errorCode: 5100, errorType: ErrorType.TECHNICAL },
};

export const getGeneralErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      GeneralErrorMap.CUSTOMER_ALREADY_REGISTER.errorCode,
      {
        errorCode: GeneralErrorMap.CUSTOMER_ALREADY_REGISTER.errorCode,
        redirectPath: OnboardingFormFields.EMAIL,
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],

    [
      GeneralErrorMap.INCORRECT_STATE.errorCode,
      {
        errorCode: GeneralErrorMap.INCORRECT_STATE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
        openModal: true,
        modalProps: {
          type: ErrorModalTypes.GENERAL,
          title: 'User in incorrect state',
          content: 'There is a problem with your user. Please contact support .',
          icon: Icons.Oops,
          buttonText: 'OK',
        },
      },
    ],

    [
      GeneralErrorMap.PLEASE_WAIT.errorCode,
      {
        errorCode: GeneralErrorMap.PLEASE_WAIT.errorCode,
        redirectPath: routesModel[RoutesMap.KYB_PENDING].path,
        relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
        callBack: () => {},
      },
    ],
  ]);
};
